import { Component, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxFormGroupComponent,
  OnyxIconComponent,
  OnyxSectionComponent,
  OnyxSuggestionsComponent,
  OnyxTimepickerComponent,
} from '@onyx/angular';
import { SuggestionHelper } from '../../../../../common/helpers/suggestions.helper';

type PointOfInterestTimesFormGroup = ReturnType<
  (typeof PointOfInterestTimesFormComponent)['buildForm']
>;

@Component({
  selector: 'app-point-of-interest-times-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxTimepickerComponent,
    OnyxIconComponent,
    TranslatePipe,
    OnyxFormGroupComponent,
    OnyxSuggestionsComponent,
  ],
  templateUrl: './point-of-interest-times-form.component.html',
  styleUrl: './point-of-interest-times-form.component.scss',
})
export class PointOfInterestTimesFormComponent {
  public readonly form = input.required<PointOfInterestTimesFormGroup>();

  protected readonly I18N = 'pointsOfInterest.times';
  protected readonly DURATION_SUGGESTIONS =
    SuggestionHelper.getDurationSuggestions();

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      averageServiceTime: fb.control<number | null>(null, [
        Validators.required,
      ]),
    });
  }
}
